// constants/userConstants.js
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAIL = 'FETCH_USERS_FAIL';
export const UPDATE_USER_PERMISSION_REQUEST = 'UPDATE_USER_PERMISSION_REQUEST';
export const UPDATE_USER_PERMISSION_SUCCESS = 'UPDATE_USER_PERMISSION_SUCCESS';
export const UPDATE_USER_PERMISSION_FAIL = 'UPDATE_USER_PERMISSION_FAIL';
// Compare this snippet from client/src/redux/reducers/userReducers.js: